import { useCallback } from 'react'
import parse from 'html-react-parser'

import { useNotification } from '../../services/providers/NotificationProvider'
import l10n from '../../components/i18n/I18N'
import { config } from '../../components/Init/Init'
import { formatCurrencyAmount, getCurrencyConfigForCurrencyId, tokenizer } from '../../services/utils'
import { useCasinoStore } from '../../services/store'

export const useShowCryptoTransactionNotification = closeNotification => {
  const casinoStore = useCasinoStore()
  const casinoHoldNotifications = casinoStore.use.casinoHoldNotifications()

  const { showNotification } = useNotification()

  const showCryptoTransactionNotification = useCallback(
    notification => {
      const notificationData = notification.context

      const isPurchaseTypeNotification = notificationData.flow === config.cryptoCurrencyNotificationFlowTypes.purchase
      const isRedemptionTypeNotification =
        notificationData.flow === config.cryptoCurrencyNotificationFlowTypes.redemption

      const isCommitStatusNotification = notificationData.status === config.cryptoCurrencyNotificationStatus.commit

      if (isRedemptionTypeNotification) {
        // for now, we do not show redemption crypto notification
        return closeNotification(notification.id, { modalData: notification })
      }

      if (isPurchaseTypeNotification && !casinoHoldNotifications) {
        const gcWallet = notificationData.walletMoneyTransfers.find(wallet => wallet.currency === 'GC')
        const scWallet = notificationData.walletMoneyTransfers.find(wallet => wallet.currency === 'SWC')

        const message = {
          [config.cryptoCurrencyNotificationStatus.pending]: parse(l10n.t['cryptopackage.purchase.detected']),
          [config.cryptoCurrencyNotificationStatus.commit]:
            isCommitStatusNotification &&
            parse(
              tokenizer(l10n.t['cryptopackage.purchase.confirmed'], {
                '{amount}': notificationData.amount,
                '{currencyId}': notificationData.currencyId,
                '{gcCurrency}': getCurrencyConfigForCurrencyId(gcWallet.currency).currencyName,
                '{gcAmount}': formatCurrencyAmount(gcWallet.amount, gcWallet.currency),
                '{scCurrency}': getCurrencyConfigForCurrencyId(scWallet.currency).currencyName,
                '{scAmount}': formatCurrencyAmount(scWallet.amount, scWallet.currency)
              })
            )
        }

        const notificationOptions = {
          [config.cryptoCurrencyNotificationStatus.pending]: {
            type: config.notificationConfigs.types.info,
            icon: config.notificationConfigs.icons.time,
            onClose: () => closeNotification(notification.id, { modalData: notification }),
            toastId: notification.id
          },
          [config.cryptoCurrencyNotificationStatus.commit]: {
            type: config.notificationConfigs.types.success,
            icon: config.notificationConfigs.icons.checkmarkEncircled,
            onClose: () => closeNotification(notification.id, { modalData: notification }),
            toastId: notification.id
          }
        }

        showNotification(message[notificationData.status], notificationOptions[notificationData.status])
      }
    },
    [casinoHoldNotifications, closeNotification, showNotification]
  )

  return { showCryptoTransactionNotification }
}
